import React, { useContext, useEffect, useRef } from 'react';
import { StoreContext } from '../context/store-context';
import XIconLg from '-!svg-react-loader!../assets/images/icons/x-lg.inline.svg';

const Lightbox = () => {
  const {
    lightboxOpen,
    setLightboxOpen,
    lightboxContent,
    setLightboxContent,
    lightboxClass,
  } = useContext(StoreContext);
  const closeButton = useRef(null);

  useEffect(() => {
    if(!lightboxOpen) {
      setTimeout(() => {
        setLightboxContent(null);
      }, 200)
    } else {
      setTimeout(() => {
        closeButton.current?.focus();
      }, 1)
    }
  }, [lightboxOpen, setLightboxContent])

  return (
    <div className={`Lightbox${lightboxOpen ? ' Lightbox--open' : ''} ${lightboxClass ? lightboxClass : ''}`}>
      <div
        className="Lightbox__overlay"
        onClick={() => setLightboxOpen(false)}
        role="presentation"
      ></div>
      <div className="Container">
        <div className="Lightbox__inner">
        <button
          className="notbutton Lightbox__close"
          aria-label="Close lightbox"
          onClick={() => setLightboxOpen(false)}
          ref={closeButton}
        >
          <XIconLg />
        </button>
          {lightboxContent}
        </div>
      </div>
    </div>
  )
}

export default Lightbox;
